import React from 'react';
import {observer} from 'mobx-react';
import {Switch, Route} from 'react-router-dom';
import RequestDetails from './RequestDetails';

const RequestsPage = observer(({match, scope}) => {
  return (
    <Switch>
      <Route path={`${match.path}/:id/:backPath?`} render={({history, match}) => <RequestDetails match={match} history={history} scope={scope}/>} />
    </Switch>
  );
});

export default RequestsPage;
